import React, { FC } from "react";
import "../assets/styles/styles.scss";
import {Link} from "react-router-dom";
import { useTypedSelector } from "../reducers";
import { logout } from "../api/AuthApi";
import { useDispatch } from "react-redux";
import { setLogout } from "../reducers/AuthSlice";
import logo from "../assets/images/shine/header_logo_black.svg";

const Header: FC = () => {
    const dispatch = useDispatch();
    const { isLogin, isAdmin } = useTypedSelector(state => state.auth);
    const { site } = useTypedSelector(state => state.profile);

    const logoutAction = async () => {
        try {
            const res = await logout();
            if (res.status === 200) {
                dispatch(setLogout());
                return;
            }
            throw new Error();
        } catch(err) {
            alert('로그아웃에 실패했습니다. 잠시 후 다시 실행해주세요.');
        }
    };

    const prepareAlert = () => {
        alert('컨텐츠 준비중입니다.');
    }

    return (
        <div className={'header-wrapper wrapper'}>
            <div className={'header-content content'}>
                <Link to={'/'}>
                    <div className={'header-logo-wrapper'}>
                        <img className={'header-logo'}
                            src={logo}
                            alt={'헤더 로고'}/>
                    </div>
                </Link>
                { isLogin && 
                    <div className={'header-button-wrapper'}>
                        <button className={'header-button'} onClick={logoutAction}>
                            Logout 
                        </button>
                        <Link to={'/mypage/22'}>
                            <button className={'header-button'}>
                                My Page
                            </button>
                        </Link>
                        { (site === 'shine' && isAdmin) && 
                            <Link to={'/admin/log/17'}>
                                <button className={'header-button'}>
                                    Admin
                                </button>
                            </Link>
                        }
                    </div>
                }
                { !isLogin && 
                    <div className={'header-button-wrapper'}>
                        <Link to={'/login'}>
                            <button className={'header-button'}>
                                Login
                            </button>
                        </Link>
                        {/*<Link to={'/join'}>*/}
                        {/*    <button className={'header-button'}>*/}
                        {/*        Join*/}
                        {/*    </button>*/}
                        {/*</Link>*/}
                    </div>
                }
            </div>
        </div>
    )
}

export default Header;
